<template lang="pug">
div
  ul#cmstab.nav.nav-tabs(role='tablist')
    template(v-if="showActionButton('bank')")
      li.nav-item(@click="refresh('bank')")
        a#bank-tab.nav-link(:class="{ 'active': currTab == 'bank' }" data-toggle='tab' href='#bank-content' role='tab' aria-controls='bank' aria-selected='false') {{ $t("ui.bank") }}
    template(v-if="showActionButton('bankstatement')")
      li.nav-item(@click="refresh('bankstatement')")
        a#bankstatement-tab.nav-link(:class="{ 'active': currTab == 'bankstatement' }" data-toggle='tab' href='#bankstatement-content' role='tab' aria-controls='bankstatement' aria-selected='false') {{ $t("ui.bank_statement") }}
    template(v-if="showActionButton('bankstatementdaily')")
      li.nav-item(@click="refresh('bankstatementdaily')")
        a#bankstatementdaily-tab.nav-link(:class="{ 'active': currTab == 'bankstatementdaily' }" data-toggle='tab' href='#bankstatementdaily-content' role='tab' aria-controls='bankstatementdaily' aria-selected='false') {{ $t("ui.bank_statement_daily") }}

  #cmstabcontent.tab-content.tab-bordered
    template(v-if="showActionButton('bank') && currTab == 'bank'")
      #bank-content.tab-pane(:class="{ 'active show': currTab == 'bank' }" role='tabpanel' aria-labelledby='bank-tab')
        bankTab(ref="bankTab" :currTab="currTab")
    template(v-if="showActionButton('bankstatement') && currTab == 'bankstatement'")
      #bankstatement-content.tab-pane.fade(:class="{ 'active show': currTab == 'bankstatement' }" role='tabpanel' aria-labelledby='bankstatement-tab')
        bankStatementTab(ref="bankStatementTab" :currTab="currTab")
    template(v-if="showActionButton('bankstatementdaily') && currTab == 'bankstatementdaily'")
      #bankstatementdaily-content.tab-pane.fade(:class="{ 'active show': currTab == 'bankstatementdaily' }" role='tabpanel' aria-labelledby='bankstatementdaily-tab')
        bankStatementDailyTab(ref="bankStatementDailyTab")

</template>

<script>
import errorTags from "@/errorTags";
import bankTab from "@/components/operatorTab/bankTab.vue";
import bankStatementTab from "@/components/operatorTab/bankStatementTab.vue";
import bankStatementDailyTab from "@/components/operatorTab/bankStatementDailyTab.vue";


export default {
  components: {
    bankTab,
    bankStatementTab,
    bankStatementDailyTab
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currTab: 'bank'
  }),
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    }
  },
  mounted: function() {  },
  methods: {
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    refresh: function(tab) {
      switch(tab) {
        case 'bank':
          this.tabChecking();
          break
        case 'bankstatement':
          this.currTab = 'bankstatement'
          this.$nextTick(() => {
            if(this.$refs.bankStatementTab) {
              this.$refs.bankStatementTab.refresh();
            }
          });
          break
        case 'bankstatementdaily':
          this.currTab = 'bankstatementdaily'
          this.$nextTick(() => {
            if(this.$refs.bankStatementDailyTab) {
              this.$refs.bankStatementDailyTab.refresh();
            }
          });
          break
      }
    },
    tabChecking() {
      if(this.showActionButton('bank')) {
        this.currTab = 'bank'
        this.$nextTick(() => {
          if(this.$refs.bankTab) {
            this.$refs.bankTab.refresh();
          }
        });
      } else if(this.showActionButton('bankstatement')) {
        this.currTab = 'bankstatement'
        this.$nextTick(() => {
          if(this.$refs.bankStatementTab) {
            this.$refs.bankStatementTab.refresh();
          }
        });
      } else if(this.showActionButton('bankstatementdaily')) {
        this.currTab = 'bankstatementdaily'
        this.$nextTick(() => {
          if(this.$refs.bankStatementDailyTab) {
            this.$refs.bankStatementDailyTab.refresh();
          }
        });
      }
    }
  }
};
</script>